// extracted by mini-css-extract-plugin
export var emptyState = "_68-d";
export var statCard = "_68-c";
export var table = "_68-0";
export var tableCell = "_68-4";
export var tableCellClickable = "_68-5 _68-4";
export var tableCellDefault = "_68-6 _68-4";
export var tableCellEmpty = "_68-8";
export var tableCellWithValue = "_68-7";
export var tableContainer = "_68-e";
export var tableHeaderWeight = "_68-1";
export var tableHeaderZone = "_68-2";
export var tableRowHeader = "_68-3";
export var viewModeButton = "_68-9";
export var viewModeButtonActive = "_68-a _68-9";
export var viewModeButtonInactive = "_68-b _68-9";